import React from 'react';
import { Modal } from 'antd';
import { CreativityContentData } from '../../types/banner';
import { AssetModalHeader } from './asset-modal-header';
import { AssetInfoPanel } from './info-panel';
import { AssetMediaPanel } from './media-panel';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';
import { useBanners } from '../../context/banners';

interface AssetModalProps {
  clientId: string;
  creativity: CreativityContentData;
  open: boolean;
  onClose: () => void;
}

export const AssetModal: React.FC<AssetModalProps> = ({ clientId, creativity, open, onClose }) => {
  const { spacing, screens } = useResponsiveSizes();
  const { refreshAllBanners } = useBanners();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={screens.lg ? 950 : '90%'}
      centered
      style={{ borderRadius: 16 }}
      styles={{
        body: {
          padding: 0,
          background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
          maxHeight: '85vh',
          overflow: screens.md ? 'hidden' : 'auto',
          display: 'flex',
          flexDirection: 'column'
        },
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'blur(10px)'
        },
        content: {
          padding: 0,
          borderRadius: 20,
          overflow: 'hidden'
        }
      }}
      closeIcon={null}
    >
      {/* Header */}
      <AssetModalHeader creativity={creativity} onClose={onClose} />

      {/* Body - Grid Layout */}
      <div
        style={{
          padding: screens.xs
            ? `${spacing.sm}px ${spacing.md}px ${spacing.md}px ${spacing.md}px`
            : screens.lg
              ? `${spacing.sm}px ${spacing.xl}px ${spacing.md}px ${spacing.xl}px`
              : `${spacing.sm}px ${spacing.lg}px ${spacing.lg}px ${spacing.lg}px`,
          display: 'grid',
          gridTemplateColumns: screens.md ? '1fr 1fr' : '1fr',
          gap: spacing.xl,
          flex: screens.md ? 1 : 'none',
          backgroundColor: 'white',
          overflow: 'hidden',
          minHeight: screens.md ? 0 : 'auto'
        }}
      >
        {/* Panel de Información (izquierda) */}
        <div
          style={{
            overflow: 'hidden',
            height: '100%',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <AssetInfoPanel creativity={creativity} clientId={clientId} onDeleted={refreshAllBanners} onClose={onClose} />
        </div>

        {/* Panel Multimedia (derecha) */}
        <div
          style={{
            overflow: 'hidden',
            height: '100%',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            scrollbarColor: '#e3e3e3 #FFFFFF'
            //scrollbarWidth: 'thin'
          }}
        >
          <AssetMediaPanel creativity={creativity} />
        </div>
      </div>
    </Modal>
  );
};
